import React, { useCallback, useEffect, useState } from 'react';
import { AppDialogHost } from './AppDialogHost';
import { registerAppDialog } from './dialogApi';
import type { AppDialogOptions, DialogAnswer } from './types';

interface PendingDialog {
  options: AppDialogOptions;
  resolve: (answer: DialogAnswer) => void;
}

export interface DialogProviderProps {
  children: React.ReactNode;
}

export function DialogProvider({ children }: DialogProviderProps) {
  const [pending, setPending] = useState<PendingDialog | null>(null);

  useEffect(() => {
    return registerAppDialog((options) =>
      new Promise<DialogAnswer>((resolve) => {
        setPending({ options, resolve });
      }),
    );
  }, []);

  const handleAnswer = useCallback((answer: DialogAnswer) => {
    setPending((current) => {
      current?.resolve(answer);
      return null;
    });
  }, []);

  return (
    <>
      {children}
      <AppDialogHost open={pending !== null} options={pending?.options} onAnswer={handleAnswer} />
    </>
  );
}
